/* eslint-disable react/no-danger */
import * as React from 'react';

// @ts-expect-error TS7016 Untyped import http://go.dkandu.me/strict-ts-migration#TS7016
import showdown from 'showdown';

import { clearEmptyFields } from 'bundles/seo/utils/utils';
import type { Faq as FaqFromGql } from 'bundles/unified-seo-content-common/__generated__/baseContentfulTypes';

type Faq = Pick<FaqFromGql, 'question' | 'answer'>;

type Props = {
  faqs?: Array<Faq>;
  rootClassName?: string;
};

/**
 * Generates FAQ Schema Markup for an article page using Google Structured Data.
 */
class ArticlePageFaqGoogleSchemaMarkup extends React.Component<Props, {}> {
  // Rationale: Contentful sends the strings to us as Markdown, we need to convert them to HTML for use
  // in our schema markup as directed by the SEO team.
  getHtmlMarkupFromConverter = (markdownSrc: string) => {
    const htmlFromConverter = this.markdownToHtmlConverter.makeHtml(markdownSrc);
    return htmlFromConverter;
  };

  markdownToHtmlConverter = new showdown.Converter();

  generateMarkup = () => {
    const { faqs } = this.props;

    return (
      faqs &&
      faqs
        // Filter returns non-null type, letting Typescript know this
        .filter((faq): faq is Faq => !!faq && !!faq.answer && !!faq.question)
        .map(({ question, answer }) => ({
          '@type': 'Question',
          name: this.getHtmlMarkupFromConverter(question as string),
          acceptedAnswer: {
            '@type': 'Answer',
            text: this.getHtmlMarkupFromConverter(answer as string),
          },
        }))
    );
  };

  render() {
    const { faqs, rootClassName } = this.props;
    if (!faqs || faqs.length === 0) {
      return null;
    }

    const markupJson = {
      '@context': 'http://schema.org',
      '@type': 'FAQPage',
      mainEntity: this.generateMarkup(),
    };

    const createMarkup = () => ({
      __html: `
        <script type="application/ld+json">
          ${JSON.stringify(clearEmptyFields(markupJson))}
        </script>
      `,
    });

    const className = rootClassName || 'rc-ArticlePageFAQSchemaMarkup';

    return (
      <div className={className}>
        <div dangerouslySetInnerHTML={createMarkup()} />
      </div>
    );
  }
}

export default ArticlePageFaqGoogleSchemaMarkup;
